import { Create, Edit, List } from "../Components/index.js";

export default [
    {
        path: "/publish/appointment-part-one",
        component: List,
        name: "publish-appt-part-one",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/publish/appointment-part-one/:id/edit",
        component: Edit,
        name: "publish-appt-part-one.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/publish/appointment-part-one/create",
        component: Create,
        name: "publish-appt-part-one.create",
        meta: {
            requiresAuth: true,
        },
    },
];
